<template>
  <div class="tab_container">
    <!-- 本月洞见/总结 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        本月洞见/总结：
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('conclusion')"
          >保存</el-button
        >
      </div>
    </div>
    <conclusion ref="conclusion" />
    <!-- 基本物价趋势 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        基本物价趋势
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('basicPriceTrends')"
          >保存</el-button
        >
      </div>
    </div>
    <basic-price-trends ref="basicPriceTrends" />
    <!-- 认证法规 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        认证法规
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('industryInfo')"
          >保存</el-button
        >
      </div>
    </div>
    <industry-info ref="industryInfo" />
  </div>
</template>

<script>
import Conclusion from "./conclusion.vue";
import BasicPriceTrends from "./basicPriceTrends.vue";
import IndustryInfo from "./industryInfo.vue";
import { getLookIndustryApi } from "@/api/saleTaskCollection";

export default {
  components: {
    Conclusion,
    BasicPriceTrends,
    IndustryInfo
  },
  data() {
    return {};
  },
  methods: {
    async init(showDataObj) {
      await this.getLookCustomer(showDataObj.queryParams);
    },
    // 获取看行业
    async getLookCustomer(queryParams = {}) {
      try {
        let data = {};
        const res = await getLookIndustryApi({
          ...queryParams
        });
        if (res.status == 0) {
          data = res.data || {};
        } else {
          this.$DonMessage.error(res.message);
        }
        this.$refs.conclusion.init(data.saleSummary, queryParams);
        this.$refs.basicPriceTrends.init(data.basicPriceResp, queryParams);
        this.$refs.industryInfo.init(data.industryPolicyResp, queryParams);

        this.$emit(
          "updateTime",
          "lookIndustryTabTime",
          this.getClosestDate([
            data.saleSummary?.updateTime,
            data.basicPriceResp.saleBasicPriceTypeList[0]?.updateTime,
            data.industryPolicyResp.saleIndustryPolicyDynamic?.updateTime
          ])
        );
      } catch (error) {}
    },
    // 获取最近的日期
    getClosestDate(dates) {
      if (dates.length === 0) return null; // 如果没有日期，返回null
      dates.sort((a, b) => a - b); // 按时间顺序排序
      return dates[0] || ""; // 取第一个元素，即最早的日期
    },
    // 保存
    handleSave(refField) {
      this.$refs[refField].handleSave(() => {
        this.$emit("updateTime");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tab_container {
  padding-bottom: 20px;
  .hearder_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title_icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .second_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .third_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 10px 10px 10px 62px;
  }
  .second_title + .third_title {
    padding-top: 25px;
  }
  .title_btn {
    margin-left: 20px;
  }
}
</style>
